import type { FC, PropsWithChildren } from "react";
import React from "react";

import { AblyNotificationProvider } from "@react/foundation/notifications";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";

export const NotificationProvider: FC<PropsWithChildren> = ({ children }) => {
  const { api } = useAuth();

  return (
    <AblyNotificationProvider subscribe={api.busAdmin.subscribeToNotifications}>
      {children}
    </AblyNotificationProvider>
  );
};
